"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var search_icon_svg_1 = __importDefault(require("res/img/search-icon.svg"));
var FilterBarSearch = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = react_1.useState(), focus = _b[0], setFocus = _b[1];
    var focusHandler = function () {
        setFocus(true);
    };
    var blurHandler = function () {
        setFocus(false);
    };
    return (react_1.default.createElement("div", { className: 'filter-bar-search', "data-focus": focus },
        react_1.default.createElement("input", { type: 'text', value: value, onChange: onChange, onFocus: focusHandler, onBlur: blurHandler, name: 'search', id: 'filter_bar_search', placeholder: 'Search' }),
        react_1.default.createElement("div", { className: 'filter-bar-search__icon' },
            react_1.default.createElement("img", { src: search_icon_svg_1.default, alt: 'Search' }))));
};
exports.default = FilterBarSearch;
